<script setup>
import DsAlert from 'JIX/components/ds/DsAlert.vue';
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/color-tip.svg';

defineProps({
    headingTag: {
        type: String,
        required: true,
    },
    heading: {
        type: String,
        required: true,
    },
    dismissable: {
        type: Boolean,
        required: false,
        default: false,
    },
});

defineEmits(['close', 'closed']);
</script>

<template>
    <DsAlert
        class="jix-small-tip"
        type="info"
        :dismissable="dismissable"
        @close="$emit('close', $event)"
        @closed="$emit('closed', $event)"
    >
        <div class="heading-tag jix-small-tip__heading-tag">
            {{ headingTag }}
            <SvgIcon
                name="color-tip"
                size="xs"
                role="presentation"
            />
        </div>
        <h5 class="jix-small-tip__heading">
            {{ heading }}
        </h5>
        <slot />
    </DsAlert>
</template>
